const capitalizeFistLetterInSentence = (data: string) => {
    if (!data) return "";
    return data !== "" && typeof data !== "undefined"
        ? data.replace(/(^\w|\s\w)/g, m => m.toUpperCase())
        : "";
};

export default capitalizeFistLetterInSentence;
